import {View, Text} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {ReportTopQuestionsCardScales} from './ReportTopQuestionsCardScales';
import {sharedStyles} from './styles/shared-styles';
import {CultureMatchItem} from '../../../../applicant/dashboard/types/ApplicantMatchesTypes';

interface Props {
  t: TFunction;
  applicantName: string;
  topQuestions: CultureMatchItem[];
  currentLanguage: 'en' | 'de';
}

export const ReportTopQuestionsSection = ({t, topQuestions, applicantName, currentLanguage}: Props) => {
  return (
    <>
      <View style={{marginBottom: '4px'}}>
        <Text style={{...sharedStyles.h2, marginBottom: 2}}>{t('screeningModule.report.topQuestions.title')}</Text>
        <Text style={{...sharedStyles.body1, marginBottom: 1}}>
          {t('screeningModule.report.topQuestions.question')}
        </Text>
        <Text style={{...sharedStyles.body1, marginBottom: 1}}>
          {t('screeningModule.report.topQuestions.description')}
        </Text>
      </View>
      <ReportTopQuestionsCardScales
        t={t}
        topQuestions={topQuestions}
        currentLanguage={currentLanguage}
        applicantName={applicantName}
      />
    </>
  );
};
